export default "__VITE_ASSET__HzLT7J3C__"